<input class="form-control" type="file" (change)="onFileSelected($event)">
